import React from 'react';
export const WeaveThemeContext = React.createContext({
    theme: undefined,
    setTheme: () => void 0,
    isWeaveActive: false,
    setIsWeaveActive: () => void 0,
});
export const useWeaveContext = () => React.useContext(WeaveThemeContext);
export const WeaveThemeConsumer = React.createContext({
    weaveThemeConsumer: { resolvedRoles: {}, metadata: {} },
    setWeaveThemeConsumer: () => void 0,
    isWeaveActive: false,
    setIsWeaveActive: () => void 0,
});
export const useWeaveThemeConsumer = () => React.useContext(WeaveThemeConsumer);
export const useConsumeWeaveTheme = () => {
    const { weaveThemeConsumer, isWeaveActive } = useWeaveThemeConsumer();
    const { theme } = useWeaveContext();
    const weave = isWeaveActive || theme === undefined;
    return {
        ...weaveThemeConsumer,
        isWeaveTheme: weave && !!theme,
        hasWeaveFlag: !!theme,
    };
};
